import React from 'react';

const Spinner = () => {
  return (
    <>
      <div className="border-[8px] border-[#f3f3f3] border-t-[8px] border-t-[#3498db] rounded-[50%] w-[2.5rem] h-[2.5rem] animate-spin"></div>
    </>
  );
};

export default Spinner;
